import { IOption } from '../../../common/common.types'
import { ISigner } from '../store/completeChart.types'

export const lockChartButtonConfigurations = (
  signersList: Array<ISigner>,
  EXTRA_SECURITY_CREW: number,
  PR_SIGNATURES: number,
  crewOptions: Array<IOption | null>
) => {
  if (PR_SIGNATURES === 0) {
    // When Electronic Signatures is set as "Not Used",then lock button is enabled
    return true
  }
  // Helper function to count verified crews
  const getVerifiedCrewCount = () =>
    signersList?.filter((signer: { verified: boolean }) => signer.verified === true).length

  // Handle EXTRA_SECURITY_CREW flag
  if (EXTRA_SECURITY_CREW === 1) {
    const isOneVerified = signersList.some((signer: { verified: boolean }) => signer.verified === true)
    return isOneVerified // Enable button if at least one is verified
  }

  if (EXTRA_SECURITY_CREW === 4) {
    const allVerified = signersList.every((signer: { verified: boolean }) => signer.verified === true)
    const requiredVerifiedCount = crewOptions.length // Number of crews
    const verifiedCrewCount = getVerifiedCrewCount()
    return allVerified && verifiedCrewCount === requiredVerifiedCount // All crews must be verified
  }

  // Handle PR_SIGNATURES flag
  if (PR_SIGNATURES === 1) {
    // Optional pin for signer, lock button can be enabled even if pin is not added
    return true // Always enable the button for this case
  }

  if (PR_SIGNATURES === 2) {
    // Require at least one verified crew
    return getVerifiedCrewCount() >= 1 // Enable if at least one crew is verified
  }

  if (PR_SIGNATURES === 4) {
    // Require at least two verified crews
    return getVerifiedCrewCount() >= 2 // Enable if at least two crews are verified
  }

  if (PR_SIGNATURES === 5) {
    // Require at least three verified crews
    return getVerifiedCrewCount() >= 3 // Enable if at least three crews are verified
  }

  if (PR_SIGNATURES === 3) {
    // Require all crews to be verified
    return getVerifiedCrewCount() === crewOptions.length // Enable if all crews are verified
  }

  // If no conditions are met, return false (button stays disabled)
  return false
}
